const KEY = 'pay_redirect'

// 结果页倒计时与按钮可能先后触发回跳，缓存首次读取结果
let consumed = false
let cachedTarget: string | null = null

const isInternalPath = (target: string) =>
  target.startsWith('/') && !target.startsWith('//') && !target.startsWith('/\\')

/**
 * 记录当前完整地址（路径 + 查询参数 + hash），供支付成功/失败后回跳。
 */
export function savePayRedirect() {
  try {
    const { pathname, search, hash } = window.location
    // 支付结果页本身不作为回跳目标
    if (/^\/[^/]+\/(paypal|payssion)(\/|$)/.test(pathname)) return
    localStorage.setItem(KEY, `${pathname}${search}${hash}`)
  } catch { /* localStorage 不可用时静默降级为跳首页 */ }
}

/**
 * 取出并清除记录的回跳地址。仅允许站内相对路径，防止 open redirect。
 */
export function consumePayRedirect(): string | null {
  if (consumed) return cachedTarget
  consumed = true
  try {
    const target = localStorage.getItem(KEY)
    localStorage.removeItem(KEY)
    if (target && isInternalPath(target)) {
      cachedTarget = target
    }
  } catch { /* ignore */ }
  return cachedTarget
}

/** 回跳到购买前页面；无记录时走 fallback（默认首页）。 */
export function goPayRedirect(fallback: () => void) {
  const redirect = consumePayRedirect()
  if (redirect) window.location.replace(redirect)
  else fallback()
}
